export default {
    methods: {
        expandStarScope(scope, allScopes) {
            // will expand * mso/partner
            // call this function if mso/partner === '*'
            // there is no need to expand * venue as it's already expanded by the api
            let result = [];
            const distinctMsos = Array(
                ...new Set(allScopes.map(item => item.mso))
            );
            const distinctPartners = Array(
                ...new Set(
                    allScopes
                        .filter(item => item.mso === scope.mso)
                        .map(item => item.partner)
                )
            );

            let expandedMsos = [scope.mso];
            let expandedPartners = [scope.partner];
            if (scope.mso === '*') {
                expandedMsos.push(...distinctMsos);
            }
            if (scope.partner === '*') {
                expandedPartners.push(...distinctPartners);
            }
            expandedMsos.forEach(mso => {
                expandedPartners.forEach(partner => {
                    result.push({
                        mso: mso,
                        partner: partner,
                        venue: scope.venue
                    });
                });
            });
            return result;
        },
        findScopeIndex(searchScope, scopeList) {
            // will return the scope index mathing mso, partner, and venue
            return scopeList.findIndex(scope => {
                return (
                    scope.mso === searchScope.mso &&
                    scope.partner === searchScope.partner &&
                    scope.venue === searchScope.venue
                );
            });
        },
        findScopeExactMatch(searchScope, scopeList) {
            // returns a scope that matches exactly the
            if (searchScope && scopeList && scopeList.length) {
                return scopeList.find(scope => {
                    return (
                        scope.mso === searchScope.mso &&
                        scope.partner === searchScope.partner &&
                        scope.venue === searchScope.venue
                    );
                });
            }
            return null;
        },
        findScopeWildcardMatch(searchScope, scopeList) {
            // returns matching parent for memberScope from the scopeList
            if (searchScope && scopeList && scopeList.length) {
                return scopeList.find(scope => {
                    return (
                        (scope.mso === '*' || scope.mso === searchScope.mso) &&
                        (scope.partner === '*' ||
                            scope.partner === searchScope.partner) &&
                        (scope.venue === '*' ||
                            scope.venue === searchScope.venue)
                    );
                });
            }
            return null;
        },
        canEditScope(memberScope, scopeList) {
            // will return true if the memberScope can be edited
            return this.hasUserScopeGrantAuthority(memberScope, scopeList);
        },
        hasUserScopeGrantAuthority(memberScope, authorizedScopes) {
            // will check if the memeberScope has grant Authority based
            // on the authorizedScopes list
            for (const scope of authorizedScopes) {
                if (scope.withGrant) {
                    if (scope.mso === '*' || scope.mso === memberScope.mso) {
                        if (
                            scope.partner === '*' ||
                            scope.partner === memberScope.partner
                        ) {
                            if (
                                scope.venue === '*' ||
                                scope.venue === memberScope.venue
                            ) {
                                return true;
                            }
                        }
                    }
                }
            }
            return false;
        },
        canEditRole(memberRole, memberScope, scopeList) {
            // will return true if memberRole from memberScope match have
            // withGrant true
            return this.canGrantRoleForUserScope(
                memberRole,
                memberScope,
                scopeList
            );
        },
        canGrantRoleForUserScope(memberRole, memberScope, authorizedScopes) {
            for (const scope of authorizedScopes) {
                if (scope.mso === '*' || scope.mso === memberScope.mso) {
                    if (
                        scope.partner === '*' ||
                        scope.partner === memberScope.partner
                    ) {
                        if (
                            scope.venue === '*' ||
                            scope.venue === memberScope.venue
                        ) {
                            if (scope.roles && scope.roles.length > 0) {
                                for (const role of scope.roles) {
                                    if (role.withGrant) {
                                        if (role.name === memberRole.name) {
                                            return true;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            return false;
        },
        getGrantableScopes(scopeList, allScopes) {
            // will return a list of scopes that has the withGrant is true
            let result = [];
            scopeList.forEach(scope => {
                if (scope.withGrant) {
                    if (scope.mso === '*' || scope.partner === '*') {
                        // need to expand the star mso/partner
                        const expandedScope = this.expandStarScope(
                            scope,
                            allScopes
                        );
                        result.push(...expandedScope);
                    } else {
                        // only add scope if it doesn't exist in the list
                        result.push({
                            mso: scope.mso,
                            partner: scope.partner,
                            venue: scope.venue
                        });
                    }
                }
            });
            return this.dedupScopeList(result);
        },
        getGrantableRoles(searchScope, scopeList) {
            let result = [];
            if (searchScope && scopeList) {
                scopeList
                    .filter(scope => {
                        return (
                            (scope.mso === '*' ||
                                scope.mso === searchScope.mso) &&
                            (scope.partner === '*' ||
                                scope.partner === searchScope.partner) &&
                            (scope.venue === '*' ||
                                scope.venue === searchScope.venue)
                        );
                    })
                    .forEach(scope => {
                        scope.roles.forEach(role => {
                            if (role.withGrant === true) {
                                result.push({
                                    id: role.id,
                                    name: role.name
                                });
                            }
                        });
                    });
            }
            // need to remove duplicate roles.
            result = this.dedupRoleList(result);
            return result;
        },
        dedupScopeList(scopeList) {
            // will remove the duplicate items
            return scopeList.filter((scope, index) => {
                return (
                    scopeList.findIndex(item => {
                        return (
                            scope.mso === item.mso &&
                            scope.partner === item.partner &&
                            scope.venue === item.venue
                        );
                    }) >= index
                );
            });
        },
        dedupRoleList(roleList) {
            // will remove duplicate items
            return roleList.filter((role, index) => {
                return (
                    roleList.findIndex(item => {
                        return item.id === role.id;
                    }) >= index
                );
            });
        },
        sortScopeList(scopeList) {
            // return a sorted scopelist
            // note this this fn will sort the array in place
            scopeList.sort((a, b) => {
                const stringA = a.mso + a.partner + a.venue;
                const stringB = b.mso + b.partner + b.venue;
                if (stringA < stringB) {
                    return -1;
                } else if (stringA > stringB) {
                    return 1;
                } else {
                    return 0;
                }
            });
        },
        assignScope(newScope, scopeList, authorizedScopes) {
            // will add new scope
            if (
                newScope &&
                newScope.mso &&
                newScope.partner &&
                newScope.venue
            ) {
                scopeList.push({
                    id: -1,
                    name: `${newScope.mso} | ${newScope.partner} | ${newScope.venue}`,
                    mso: newScope.mso,
                    partner: newScope.partner,
                    venue: newScope.venue,
                    withGrant: false,
                    disableEdit: !this.canEditScope(newScope, authorizedScopes),
                    roles: []
                });
                return true;
            }
            return false;
        },
        assignRole(newRole, parentScope, authorizedScopes) {
            // will add new role to specified scope
            if (newRole && parentScope) {
                parentScope.roles.push({
                    id: -1,
                    roleId: newRole.id,
                    name: newRole.name,
                    withGrant: false,
                    info: null,
                    error: null,
                    disableEdit: !this.canEditRole(
                        newRole,
                        parentScope,
                        authorizedScopes
                    )
                });
                return true;
            }
            return false;
        },
        unAssignScope(targetScope, scopeList) {
            // remove the scope from the list
            const toBeRemovedScopeIndex = this.findScopeIndex(
                targetScope,
                scopeList
            );
            if (toBeRemovedScopeIndex >= 0) {
                scopeList.splice(toBeRemovedScopeIndex, 1);
                return true;
            }
            return false;
        },
        unAssignRole(targetRole, parentScope) {
            // remove the role from the parentScope roles
            if (targetRole && parentScope && parentScope.roles) {
                const toBeRemovedRoleIndex = parentScope.roles.findIndex(
                    role => {
                        return role.roleId === targetRole.roleId;
                    }
                );
                if (toBeRemovedRoleIndex >= 0) {
                    parentScope.roles.splice(toBeRemovedRoleIndex, 1);
                    return true;
                }
            }
            return false;
        },
        diffUserScopes(userScopes, originUserScopes) {
            // will find the diff beween the two userScopes arrays
            // new scopes
            const newScopes = this.getNewScopes(userScopes);
            // deleted scope
            const deletedScopes = this.getDeletedScopes(
                userScopes,
                originUserScopes
            );
            // updated scopes
            const updatedScopes = this.getUpdatedScopes(
                userScopes,
                originUserScopes
            );
            return {
                added: newScopes,
                deleted: deletedScopes,
                updated: updatedScopes
            };
        },
        getNewScopes(userScopes) {
            return userScopes
                .filter(scope => {
                    return scope.id === -1;
                })
                .map(scope => {
                    return {
                        isNew: true,
                        mso: scope.mso,
                        partner: scope.partner,
                        venue: scope.venue,
                        withGrant: scope.withGrant,
                        userScopeRoles: scope.roles.map(role => {
                            return {
                                roleId: role.roleId,
                                withGrant: role.withGrant
                            };
                        })
                    };
                });
        },
        getDeletedScopes(userScopes, originalScopes) {
            return originalScopes
                .filter(scope => {
                    return this.findScopeIndex(scope, userScopes) === -1;
                })
                .map(scope => {
                    return {
                        isDeleted: true,
                        id: scope.id
                    };
                });
        },
        getUpdatedScopes(userScopes, originalScopes) {
            const updatedScopes = [];
            userScopes.forEach(scope => {
                const originalScope = this.findScopeExactMatch(
                    scope,
                    originalScopes
                );
                // if found and not new scope
                if (scope.id > 0 && originalScope) {
                    updatedScopes.push({
                        isDirty: scope.withGrant !== originalScope.withGrant,
                        id: scope.id,
                        withGrant: scope.withGrant,
                        userScopeRoles: this.constructUpdatedRoles(
                            scope.roles,
                            originalScope.userScopeRoles
                        )
                    });
                }
            });
            return updatedScopes;
        },
        constructUpdatedRoles(targetRoles, originalRoles) {
            // will compare if the userScopeRole is
            // check for new roles
            const newRoles = this.getNewRoles(targetRoles);
            // check for deleted roles
            const deletedRoles = this.getDeletedRoles(
                targetRoles,
                originalRoles
            );
            // check for updated roles
            const updatedRoles = this.getUpdatedRoles(
                targetRoles,
                originalRoles
            );

            return [...newRoles, ...deletedRoles, ...updatedRoles];
        },
        getNewRoles(targetRoles) {
            return targetRoles
                .filter(role => {
                    return role.id === -1;
                })
                .map(role => {
                    return {
                        isNew: true,
                        roleId: role.roleId,
                        withGrant: role.withGrant
                    };
                });
        },
        getDeletedRoles(targetRoles, originalRoles) {
            return originalRoles
                .filter(role => {
                    return !targetRoles.find(newRole => {
                        return newRole.roleId === role.roleId;
                    });
                })
                .map(role => {
                    return {
                        isDeleted: true,
                        id: role.id
                    };
                });
        },
        getUpdatedRoles(targetRoles, originalRoles) {
            return targetRoles
                .filter(role => {
                    return (
                        role.id !== -1 &&
                        originalRoles.find(originalRole => {
                            return (
                                originalRole.roleId === role.roleId &&
                                originalRole.withGrant !== role.withGrant
                            );
                        })
                    );
                })
                .map(role => {
                    return {
                        isDirty: true,
                        id: role.id,
                        roleId: role.roleId,
                        withGrant: role.withGrant
                    };
                });
        },
        transformUserScopesData(
            userScopes,
            grantableScopes,
            isRoleDataSimpleFormat
        ) {
            // convert assigned scopes/roles from db format to UI friendly format
            // userScopes: the target user scopes data object
            // grantableScopes: the logged in user grantable scopes
            // isRoleDataSimpleFormat: if the data is simple or extanded
            if (userScopes && userScopes.length && grantableScopes) {
                const rolesNodeName = isRoleDataSimpleFormat
                    ? 'roles'
                    : 'userScopeRoles';
                return userScopes.map(scope => {
                    return {
                        id: scope.id,
                        name: `${scope.mso} | ${scope.partner} | ${scope.venue}`,
                        mso: scope.mso,
                        partner: scope.partner,
                        venue: scope.venue,
                        withGrant: scope.withGrant,
                        disableEdit: !this.canEditScope(scope, grantableScopes),
                        roles: scope[rolesNodeName].map(role => {
                            if (isRoleDataSimpleFormat) {
                                return this.transformRoleDataSimple(
                                    role,
                                    !this.canEditRole(
                                        role,
                                        scope,
                                        grantableScopes
                                    )
                                );
                            } else {
                                return this.transformRoleDataExpanded(
                                    role,
                                    !this.canEditRole(
                                        role.role,
                                        scope,
                                        grantableScopes
                                    )
                                );
                            }
                        })
                    };
                });
            }
            return [];
        },
        transformRoleDataSimple(role, disableEdit) {
            // transforms role data from simple format
            return {
                name: role.name,
                id: 0,
                roleId: role.id,
                withGrant: role.withGrant,
                info: null,
                error: null,
                disableEdit: disableEdit
            };
        },
        transformRoleDataExpanded(role, disableEdit) {
            // transforms role data from expanded format
            return {
                name: role.role.name,
                id: role.id,
                roleId: role.roleId,
                withGrant: role.withGrant,
                info: null,
                error: null,
                disableEdit: disableEdit
            };
        },
        isScopeWildcardMatch(scope) {
            if (scope) {
                return (
                    scope.mso === '*' ||
                    scope.partner === '*' ||
                    scope.venue === '*'
                );
            }
            return false;
        }
    }
};
